/**
 * @file
 * Search Modal script.
 */

(function searchModalScript($, Drupal, drupalSettings, _) {
  'use strict';

  function searchInputTypeSize() {
    $('.dynamic-search__input').on('input', function () {
      var $this = $(this);
      var inputFontSize = parseInt($this.css('font-size'), 10);
      var inputCharCount = $this.val().length;
      var inputWidth = parseInt($this.outerWidth(), 10) + 90;

      // If input font size are set to default, check to see if the text
      // overflows the input. If they do, shrink the font size.
      if ([96, 48].indexOf(inputFontSize) > -1 && (inputCharCount * inputFontSize) > inputWidth) {
        var shrinkFontSize = 0;
        if (inputFontSize === 96) {
          shrinkFontSize = 36;
        }
        else {
          shrinkFontSize = 24;
        }
        $this.css('font-size', shrinkFontSize + 'px');
      }
      // If input font size are set to shrunk font sizes, check to see if the
      // text won't overflow the input. If they do, grow the font size.
      if ([36, 24].indexOf(inputFontSize) > -1) {
        var growFontSize = 0;
        if (inputFontSize === 36) {
          growFontSize = 96;
        }
        else {
          growFontSize = 48;
        }

        if ((inputCharCount * growFontSize) < inputWidth) {
          $this.css('font-size', growFontSize + 'px');
        }
      }
    });
  }

  Drupal.behaviors.searchModal = {
    attach: function searchModalAttach(context) {
      var $modalContainer = $('.search-modal', context);
      var $searchHeaderInput = $('.header-search-trigger__input', context);
      var $menuSearchLink = $('.menu--search > li > a', context);
      // Initialize the search component.
      window.dispatchEvent(new CustomEvent('search-render: full'));

      if ($searchHeaderInput.length) {
        var $triggerIcon = $('.header-search-trigger__trigger .icon--search-alt', context);

        $searchHeaderInput.focus();
        // Render search component in modal but the modal hidden until the user takes a
        // pause in their typing.
        $searchHeaderInput.on('input', function () {
          $triggerIcon.animateCss('fadeOutLeft', function () {
            $triggerIcon.hide();
          });

          window.pinSearch.doSearch($(this).val());
        });
        // Make the modal visible, with pre-rendered search component.
        $searchHeaderInput.on('input', _.debounce(function () {
          var siteHeight = $('.site', context).height() - 53;
          $modalContainer.css({height: siteHeight + 'px'}).show().animateCss('fadeIn');
          $('.dynamic-search__input', context).focus();
          $menuSearchLink.addClass('active');
          searchInputTypeSize();
        }, 400));
      }

      // Reset font size when search reset is clicked.
      $modalContainer
        .on('click', '.dynamic-search__reset', function () {
          $('.dynamic-search__input').removeAttr('style');
        })
        .on('keypress', function (e) {
          if ((e.which === 13) && (!(e.target.classList.contains('dynamic-search__reset'))) && (!(e.target.classList.contains('search-modal__close-button')))) {
            // We prepend currentLanguage so the user is always sent to
            // the correct full page results.
            var currentLanguage = drupalSettings.path.currentLanguage;
            var link = ($('.dynamic-search__result-more').length) ? $('.dynamic-search__result-more').attr('href') : '/' + currentLanguage + '/search' + window.location.hash;
            window.location.href = link;
          }
          else if (e.target.classList.contains('dynamic-search__reset')) {
            // if user hits the reset return focus to the input.
            $('.dynamic-search__input').focus();
          }
        });

      // Workaround Drupal's limits for required fields.
      $menuSearchLink.text('').attr('href', '/#');
      // Navigation search icon trigger.
      $menuSearchLink
        .hammer()
        .on('tap press click', function (e) {
          e.preventDefault();
          window.dispatchEvent(new CustomEvent('search-render: full'));
          $(this).addClass('active');
          var siteHeight = $('.site', context).height() - 53;
          $modalContainer.css({height: siteHeight + 'px'}).show().animateCss('fadeIn');
          $('.dynamic-search__input', context).focus();

          // If mobile menu is active when the search icon is clicked, we want
          // to close the mobile menu and show the site content.
          if ($(window).width() < 1024) {
            var $menuToggle = $('.menu__toggle', context);
            if ($menuToggle.hasClass('menu__toggle--open')) {
              $menuToggle
                .toggleClass('menu__toggle--collapsed')
                .toggleClass('menu__toggle--open');
              $('.menu--mobile', context).slideToggle('fast');
              $('.site__content, .site__footer', context).show();
              window.scrollTo(0, 0);
            }
          }

          searchInputTypeSize();
        });

      // Closing search modal.
      $('.search-modal__close-button', context)
        .hammer()
        .on('tap press click', function (e) {
          e.preventDefault();
          closeSearchModal();
        });
      // Close search from escape key.
      $(document).on('keyup', function (evt) {
        if (evt.keyCode === 27
            && $modalContainer.length
            && $modalContainer.is(':visible')) {
          closeSearchModal();
        }
      });
      // Shared function for closing modal.
      function closeSearchModal() {
        if ($searchHeaderInput.length) {
          $searchHeaderInput.val('').focus();
          $triggerIcon.show().animateCss('fadeInLeft'); // eslint-disable-line block-scoped-var
        }

        $modalContainer.animateCss('fadeOut', function () {
          $modalContainer.hide();
        });
        $menuSearchLink.removeClass('active');
      }
    }
  };
}(jQuery, Drupal, drupalSettings, _));
